import { render, staticRenderFns } from "./syalert.vue?vue&type=template&id=1dcf8f85"
import script from "./syalert.vue?vue&type=script&lang=js"
export * from "./syalert.vue?vue&type=script&lang=js"
import style0 from "./syalert.vue?vue&type=style&index=0&id=1dcf8f85&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports